import { PurchaseDto, UpdatePurchaseDto, DownloadFileDto } from '@sr/dto';
import { FormTools } from 'utils/form-tools';

export type FormData = {
  status: number | '';
  invoiceScan: DownloadFileDto[];
  bankDetailsScan: DownloadFileDto[];
  wccScan: DownloadFileDto[];
  promoScan: DownloadFileDto[];
  photoProof: DownloadFileDto[];
};

export const formTools: FormTools<PurchaseDto, void, UpdatePurchaseDto, FormData> = {
  toCreateDto: (formData) => null,

  toUpdateDto: (purchaseId, formData): UpdatePurchaseDto => ({
    id: Number(purchaseId),
    statusId: Number(formData.status),
    invoiceScan: formData.invoiceScan,
    bankDetailsScan: formData.bankDetailsScan,
    wccScan: formData.wccScan,
    promoScan: formData.promoScan,
    photoProof: formData.photoProof
  }),

  fromDto: (dto): FormData => ({
    status: dto.status.id,
    invoiceScan: dto.invoiceScan ?? [],
    bankDetailsScan: dto.bankDetailsScan ?? [],
    wccScan: dto.wccScan ?? [],
    photoProof: dto.photoProof,
    promoScan: dto.promoScan
  }),

  validate: (values: FormData) => {
    let validationResult: Partial<{ [x in keyof FormData]: string }> = {};
    return validationResult;
  },

  emptyValues: () => ({
    status: '',
    invoiceScan: [],
    bankDetailsScan: [],
    wccScan: [],
    promoScan: [],
    photoProof: []
  })
};
